import { IconSchool, IconShieldX, IconStar, IconUserPlus, IconUsers } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '~/components/ui/sidebar'

type NavItem = {
  title: string
  url: string
  icon: typeof IconShieldX
}

type NavGroup = {
  label: string
  items: NavItem[]
}

export function NavMain() {
  const { t } = useTranslation()
  const location = useLocation()

  const groups: NavGroup[] = [
    {
      label: t('sidebar.masterData'),
      items: [
        {
          title: t('sidebar.ngWords'),
          url: '/ng-words',
          icon: IconShieldX,
        },
        // HER-311: Category Applications, Category Requests, and Service
        // Packages entries removed (pages disabled — service packages are
        // managed via Apple/Google IAP).
        {
          title: t('sidebar.skills'),
          url: '/skills',
          icon: IconStar,
        },
        {
          title: t('sidebar.schools'),
          url: '/schools',
          icon: IconSchool,
        },
      ],
    },
    {
      label: t('sidebar.userManagement.label'),
      items: [
        {
          title: t('sidebar.userManagement.users'),
          url: '/users',
          icon: IconUsers,
        },
        {
          title: t('sidebar.userManagement.referrals'),
          url: '/referrals',
          icon: IconUserPlus,
        },
      ],
    },
  ]

  return (
    <>
      {groups.map((group) => (
        <SidebarGroup key={group.label}>
          <SidebarGroupLabel>{group.label}</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {group.items.map((item) => (
                <SidebarMenuItem key={item.url}>
                  <SidebarMenuButton asChild isActive={location.pathname.startsWith(item.url)} tooltip={item.title}>
                    <Link to={item.url}>
                      <item.icon />
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      ))}
    </>
  )
}
